import apiClient from './apiClient';

// Step-up admin re-verification (no new session). Used by approval gates:
// Inward GPS override and FOB excess-scan approval.
export const verifyAdmin = async (email, password) => {
  const res = await apiClient.post('/auth/verify-admin', { email, password });
  return res.data;
};
